import { FlexRow } from "src/components/ui/common";
import { colors } from "src/theme";
import styled from "styled-components";

export const ContactLink = styled(FlexRow)`
  padding-block: 8px;
  position: relative;
  div,
  p {
    z-index: 5;
  }
  :after {
    content: "";
    background-color: ${colors.mainLight};
    border-radius: 8px;
    position: absolute;
    inset: 0;
    inset-inline: -12px;
    opacity: 0;
    transition: all 200ms ease-in-out;
    z-index: 1;
  }
  :hover {
    :after {
      opacity: 1;
    }
  }
`;
